import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MaterialsCardInputFragment = { __typename: 'Material', id: string, legacyId: number, name?: string | null, organization?: { __typename: 'Organization', id: string, name?: string | null } | null, galleryImage?: { __typename: 'DataObject', id: string } | null };

export type MaterialCardFragment = { __typename: 'MaterialCardByUuid', id: string, nextActor: Types.NextActor, state: Types.MaterialState, currentUserAssignment?: { __typename: 'MaterialCardUser', id: string, firstName?: string | null, lastName?: string | null, galleryImage?: { __typename: 'MaterialCardGalleryImage', id: string } | null } | null, organization?: { __typename: 'MaterialCardOrganization', id: string } | null, tagAssignments: Array<{ __typename: 'MaterialCardTagAssignment', id: string, tag: { __typename: 'MaterialCardTag', id: string, legacyId: number, name: string, description?: string | null, color?: string | null, type: Types.TagType, createdBy?: { __typename: 'MaterialCardTagCreatedBy', id: string } | null, organization?: { __typename: 'MaterialCardTagOrganization', id: string, legacyId: number } | null } }>, taskInfos: { __typename: 'MaterialCardTaskInfos', inProgress: number, waitingForFeedback: number, completed: number, archived: number } };

export type MaterialsCardDataQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type MaterialsCardDataQuery = { __typename: 'Query', materialCardDataById: Array<{ __typename: 'MaterialCardByUuid', id: string, nextActor: Types.NextActor, state: Types.MaterialState, currentUserAssignment?: { __typename: 'MaterialCardUser', id: string, firstName?: string | null, lastName?: string | null, galleryImage?: { __typename: 'MaterialCardGalleryImage', id: string } | null } | null, organization?: { __typename: 'MaterialCardOrganization', id: string } | null, tagAssignments: Array<{ __typename: 'MaterialCardTagAssignment', id: string, tag: { __typename: 'MaterialCardTag', id: string, legacyId: number, name: string, description?: string | null, color?: string | null, type: Types.TagType, createdBy?: { __typename: 'MaterialCardTagCreatedBy', id: string } | null, organization?: { __typename: 'MaterialCardTagOrganization', id: string, legacyId: number } | null } }>, taskInfos: { __typename: 'MaterialCardTaskInfos', inProgress: number, waitingForFeedback: number, completed: number, archived: number } }> };

export const MaterialsCardInputFragmentDoc = gql`
    fragment MaterialsCardInput on Material {
  id
  legacyId
  name
  organization {
    id
    name
  }
  galleryImage {
    id
  }
}
    `;
export const MaterialCardFragmentDoc = gql`
    fragment MaterialCard on MaterialCardByUuid {
  __typename
  id
  currentUserAssignment {
    id
    firstName
    lastName
    galleryImage {
      id
    }
  }
  organization {
    id
  }
  nextActor
  state
  tagAssignments {
    id
    tag {
      id
      legacyId
      createdBy {
        id
      }
      name
      description
      color
      type
      organization {
        id
        legacyId
      }
    }
  }
  taskInfos {
    inProgress
    waitingForFeedback
    completed
    archived
  }
}
    `;
export const MaterialsCardDataDocument = gql`
    query materialsCardData($ids: [ID!]!) {
  materialCardDataById(ids: $ids) {
    ...MaterialCard
  }
}
    ${MaterialCardFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialsCardDataGQL extends Apollo.Query<MaterialsCardDataQuery, MaterialsCardDataQueryVariables> {
    override document = MaterialsCardDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }